export const DEFAULT_LINE_ITEM = {
    "practiceId": 0,
    "addedBy": "",
    "updatedBy": "",
    "updatedDate": "",
    "inActive": false,
    "inActiveReason": "",
    "inActiveBy": "",
    "inActiveDate": "",
    "id": 0,
    identifier: 0,
    "itemType": "OUTBAL",
    "itemDescription": "",
    "serviceDate": "",
    "amount": 0
}

export const DEFAULT_PAYMENT_MODEL = {
    "practiceId": 0,
    "addedBy": "",
    "inActive": false,
    "id": 0,
    "locationId": "",
    "depositDate": "",
    "receiptNumber": "",
    "copayDOS": "",
    "paymentType": "PATIENT",
    "patientId": "",
    accountNumber: "",
    "amount": "",
    "notes": "",
    "isCopay": false,
    "paymentSource": "",
    "paymentAttachments": [],
    patientPaymentType: "PAY_REC",//PAY_REC|PAY_REQ|CC_PMT|CC_RDR

    recordPaymentMethod: 'CASH',//CASH|CHECK
    checkNumber: '',
    receivedDate: "",

    requestedVia: 'Email',
    requestEmail: '',
    requestPhone: '',
    requestedTo: "",

    stripeSettingsId: "",

    "cardPaymentMethod": "SAVED", //SAVED|NEW
    "paymentMethodId": "",
    "cardType": "",
    "last4Digits": "",
    "terminalId": "",
    "readerName": "",

    "isDiscount": false,
    "discountType": "FLAT",//FLAT|PER
    "discountValue": 0,
    "discountReason": "",

    "isCCFees": false,
    "ccFees": 0,
    "ccFeePercentage": 2.7,

    "paidAmount": "",


}


export const DEFAULT_VALIDATION_MODEL = {
    patientIdError: null,
    locationIdError: null,
    receivedDateError: null,
    checkNumberError: null,
    requestEmailError: null,
    requestPhoneError: null,
    stripeSettingsIdError: null,
    last4DigitsError: null,
    discountValueError: null,
}

export const ALLOWED_FILE_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
];